import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";

export const getLinkTexts = ({ onResponse, onError }) => {
  fetch(
    '/api/link_text_to_avoid_in_job_searches',
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const createLinkText = ({ onResponse, onError, body }) => {
  fetch(
    '/api/link_text_to_avoid_in_job_searches',
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const deleteLinkText = ({ linkTextId, onResponse, onError, body }) => {
  fetch(
    `/api/link_text_to_avoid_in_job_searches/${linkTextId}`,
    {
      method: HTTPRequestMethods.DELETE,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
